import { I as Icon, _ as _extends } from './Icon-f29ff1c6.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Star = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M12 18.6981l6.1245 3.6965c.4489.2709 1.0028-.1316.8836-.6423l-1.6252-6.9669 5.4116-4.6881c.3964-.3434.1845-.9945-.338-1.0388l-7.1248-.6045-2.7859-6.573c-.2043-.482-.8873-.482-1.0916 0L8.6683 8.454l-7.1248.6045c-.5225.0443-.7344.6954-.338 1.0388l5.4116 4.6881-1.6252 6.9669c-.1192.5107.4347.9132.8836.6422L12 18.6981z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M12 16.2496l4.1573 2.5092-1.1033-4.7293 3.6748-3.1835-4.8339-.4101L12 5.9649l-1.8949 4.471-4.834.4101 3.6749 3.1835-1.1033 4.7293L12 16.2496zm-6.1245 6.1449c-.449.271-1.0028-.1315-.8836-.6422l1.6252-6.9669-5.4116-4.6881c-.3964-.3434-.1845-.9945.338-1.0388l7.1248-.6045 2.7859-6.573c.2043-.482.8873-.482 1.0916 0l2.7859 6.573 7.1248.6045c.5225.0443.7344.6954.338 1.0388l-5.4116 4.6881 1.6252 6.9669c.1192.5107-.4347.9132-.8836.6423L12 18.6981l-6.1245 3.6964z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Star.displayName = "StarIcon";

export { Star, Star as default };
